import WordCard, { WordProps } from "./WordCard"

export default WordCard
export { WordProps }
